/**
 * Maximally distinct colors selected for perceptual distance.
 * All colors have sufficient contrast for legibility on white backgrounds.
 * Each color is visually distinct from all others - no similar hues.
 */
export const colors = [
    '#e6194b',  // red
    '#3cb44b',  // green
    '#0000ff',  // pure blue
    '#f58231',  // orange
    '#911eb4',  // purple
    '#0094b5ff',  // cyan
    '#f032e6',  // magenta
    '#9a6324',  // brown
    '#848400ff',  // olive
    '#000075',  // navy
    '#469990',  // teal
    '#9d00ffff',  // lavender
    '#09ff53ff',  // mint
    '#d0b100ff',  // gold
    '#800000',  // maroon
    '#008080',  // dark teal
]
